import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import HotelService from "./hotelService";


export const getHotels = createAsyncThunk("Hotel/get-Hotels", async (thunkAPI) => {
  try {
    return await HotelService.getHotels();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createHotels = createAsyncThunk(
  "Hotel/create-Hotels",
  async (HotelData, thunkAPI) => {
    try {
      return await HotelService.createHotels(HotelData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getHotel = createAsyncThunk(
  "Hotel/get-Hotel",
  async (id, thunkAPI) => {
    try {
      return await HotelService.getHotel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateHotel = createAsyncThunk(
  "Hotel/update-Hotel",
  async (brand, thunkAPI) => {
    try {
      return await HotelService.updateHotel(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAHotel = createAsyncThunk(
  "Hotel/delete-Hotel",
  async (id, thunkAPI) => {
    try {
      return await HotelService.deleteHotel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Hotels: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const HotelSlice = createSlice({
  name: "Hotel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHotels.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHotels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Hotels = action.payload.data;
      })
      .addCase(getHotels.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createHotels.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createHotels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdHotel = action.payload;
      })
      .addCase(createHotels.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHotel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.hotelemail= action.payload.data.email;
        state.hotelName= action.payload.data.name;
        state.hotelPassword= action.payload.data.password;
        
       
        
        
        
      })
      .addCase(getHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateHotel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedHotel = action.payload;
      })
      .addCase(updateHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAHotel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedHotel = action.payload;
      })
      .addCase(deleteAHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default HotelSlice.reducer;
